import React from 'react'
import { useHistory } from 'react-router-dom'
import jsbridge from "@xpeng/js-bridge";
import classNames from 'classnames';
import { getDistanceText } from "../../../../utils/common";
import { sendReport } from '../../../../utils/reporter';
import ScoreLine from '../ScoreLine';
import './index.scss';
import { findServiceItemsParam } from '../../utils';
import StoreSelector from '../../StoreSelector';

export default function ReserveStoreCard(props) {
  const { storeContent, reserveItems = [] } = props;
  const history = useHistory()
  const { serviceItems, eventCode, repairDescList } = findServiceItemsParam(reserveItems);

  const onTapMoreStores = () => {
    history.push(`${history.location.pathname}${history.location.search}#select-store`);
    sendReport({
      mcode: "更换门店入口点击",
      point: 'P11183`B010',
    })
  }

  const openMap = data => {
    const { name, lat, lot } = data;
    jsbridge.callHandler('navigate', {
        label: name,
        latitude: Number(lat),
        longitude: Number(lot),
      })
    
    sendReport({
      mcode: "门店列表查看导航点击",
      point: 'P11183`P11183',
    })
  };

  if (!storeContent) return null;

  return (
    <div className="reserve-store-container">
      <div className="header-field">
        <span className="header-title">预约门店</span>
        <span className="more-field" onClick={onTapMoreStores}>
          切换城市/门店
          <i className="arrow-right-icon" />
        </span>
      </div>
      <div
        className={classNames("body-field", {
          'store-disabled': !!storeContent.groupFive,
        })}
      >
        <div className="store-title">
          <span
            className={classNames("title-text", {
              'middle-length': !!storeContent?.isUserDefaultShop || (storeContent.tags && storeContent.tags[0]),
              'short-length': !!storeContent?.isUserDefaultShop && storeContent.tags && storeContent.tags[0]
            })}
          >
            {`${storeContent?.name || '--'} `}
            {
            storeContent?.groupFive && (
              <span className="suspend-label">
                暂停营业
              </span>
              )
            }
            {
              !!storeContent?.isUserDefaultShop && (
              <span className="store-label">专属门店</span>
              )
            }
            {/* {
              storeContent.tags && storeContent.tags[0] === "常去" && (
                <span className="usual-store-label">常去门店</span>
              )
            } */}
          </span>
        </div>
        <div className="distance-address">
          {
            storeContent?.distance ? (
              <span className="distance-text">
                {
                  storeContent.distance ? `${getDistanceText(storeContent.distance)}｜` : ''
                }
              </span>
            ) : null
          }
          <span className="addr-text">{storeContent?.linkAddr}</span>
        </div>
        <div className='score-line'>
          <ScoreLine scoreInfo={storeContent?.score} />
        </div>
        <div className="tips-field">
          {
            storeContent?.shopTags?.length > 0 ? (
              <div className="labels-field">
                {
                  storeContent?.shopTags.map((tag, i) => {
                    return (
                      <div key={i} className="tag-item">{tag}{i === (storeContent.shopTags.length - 1) ? '' : '｜'}</div>
                    );
                  })
                }
              </div>
            ) : null
          }
          {/* <span>保养超时免单｜60分钟快保｜周五服务至22:00</span> */}
        </div>
        {
          storeContent?.groupFive && (
            <span className="suspend-desc">
              {storeContent.groupFive}
            </span>
            )
        }
        <div className="actions-field">
          {
            !!storeContent.lat && !!storeContent.lot && (
              <div
                className="nav-btn"
                onClick={e => {
                  e.stopPropagation();
                  openMap({ name: storeContent.name, lat: storeContent.lat, lot: storeContent.lot });
                }}
              />
            )
          }
          {
            !!storeContent.linkTel && storeContent.linkTel !== '0' && (
              <a
                href={`tel:${storeContent.linkTel}`}
                className='info-content'
                onClick={e => {
                  e.stopPropagation();
                  sendReport({
                    mcode: "门店列表查看电话点击",
                    point: 'P11183`B014',
                  })
                }}
              >
                <div className="phone-btn" />
              </a>
            )
          }
        </div>
      </div>
      <StoreSelector serviceItems={serviceItems} eventCode={eventCode} childServiceItems={repairDescList} />
    </div>
  );
}
